import { css } from 'styled-components';

export type FontWeightProps = {
  fontWeight?: '300' | '400' | '500' | '700' | '900' | CSSGlobalRuleValue;
};

export const withSecondaryTypeface = `
  font-family: var(--secondary-font-family);
`;

export const withPrimaryTypeface = `
  font-family: var(--primary-font-family);
`;

export type WithTypefaceProps = {
  typeface?: 'Primary' | 'Secondary';
};

export const withTypeface = css`
  ${({ typeface }: WithTypefaceProps) => {
    switch (typeface) {
      case 'Secondary':
        return withSecondaryTypeface;
      case 'Primary':
        return withPrimaryTypeface;
      default:
        return '';
    }
  }}
`;

export const withFontWeight = css`
  ${function setFontWeight({ fontWeight }: FontWeightProps): string {
    if (!fontWeight) {
      return '';
    }
    return `
      font-weight: ${fontWeight};
    `;
  }}
`;

export type FontStyleProps = {
  fontStyle: 'normal' | 'italic' | CSSGlobalRuleValue;
};

export const withFontStyle = css`
  ${function setFontWeight({ fontStyle }: FontStyleProps): string {
    if (!fontStyle) {
      return '';
    }
    return `
      font-style: ${fontStyle};
    `;
  }}
`;

export type TextAlignProps = {
  textAlign?: 'left' | 'right' | 'center' | CSSGlobalRuleValue;
};

export const withTextAlign = css`
  ${function setTextAlign({ textAlign }: TextAlignProps): string {
    if (!textAlign) {
      return '';
    }
    return `
      text-align: ${textAlign};
    `;
  }};
`;

export type FontSizeProps = {
  fontSize?: string;
};

export const withFontSize = css`
  ${function setFontSize({ fontSize }: FontSizeProps): string {
    if (!fontSize) {
      return '';
    }
    return `
      font-size: ${fontSize};
    `;
  }};
`;
